module.exports = __webpack_public_path__ + "img/iced-tea.e67a6e87.svg";